module.exports = __webpack_public_path__ + "static/media/error-image.badcc6dd.png";